export default "__VITE_ASSET__CiT2wVgH__"